"use client";

import React from "react";
import Section from "@/components/layout/Section";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function Carousel({ id, className, ...props }: CarouselProps) {
  const scrollNext = useCarouselStore(state => state.scrollNext);
  const scrollPrev = useCarouselStore(state => state.scrollPrev);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const handleScrollNext = React.useCallback(() => {
    scrollNext();
  }, [scrollNext]);

  const handleScrollPrev = React.useCallback(() => {
    scrollPrev();
  }, [scrollPrev]);

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        handleScrollPrev();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        handleScrollNext();
      }
    },
    [handleScrollPrev, handleScrollNext],
  );

  return (
    <Section
      id={`${id ? `${id}-` : ""}carousel`}
      aria-label="Gallery carousel"
      onKeyDownCapture={handleKeyDown}
      className={cn("relative", className, classes)}
      data-slot="carousel"
      {...native}
    />
  );
}

export default Carousel;
